<template>
  <div class="wrap-detail">
    <div class="title-page">Detail History</div>
  </div>
</template>

<script>
export default {
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getDetailHistory", id);
  },
};
</script>

<style></style>
